// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SmileySmileIconSignature {
  Element: SVGSVGElement;
}

export const SmileySmileIcon: TOC<SmileySmileIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.486 2 2 6.486 2 12C2 17.515 6.486 22 12 22C17.514 22 22 17.515 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20ZM8.801 14.402C9.566 15.418 10.732 16 12 16C13.27 16 14.437 15.417 15.2 14.4L16.8 15.602C15.655 17.126 13.905 18 12 18C10.098 18 8.35 17.128 7.203 15.606L8.801 14.402ZM7 8H11V10H7V8ZM17 8H13V10H17V8Z"/>
</svg>
</template>;